import {createSelector, MemoizedSelector} from '@ngrx/store';

import {AppState} from 'sp-mark/redux';
import {PaymentConclusionState} from 'sp-mark/redux/payment-conclusion/payment-conclusion.reducers';

const selectFeature = (appState: AppState) => appState.paymentConclusion;

export const selectOperation = createSelector(selectFeature, (state: PaymentConclusionState) => (state ? state.operationInfo : undefined));

export const selectOperationAvailability = createSelector(selectFeature, (state: PaymentConclusionState) =>
  state ? state.flagUnavailableOperation : undefined
);

export const selectLoader = createSelector(selectFeature, (state: PaymentConclusionState) =>
  state ? state.flagLoadingContent : undefined
);

export const selectModuleLoader = createSelector(selectFeature, (state: PaymentConclusionState) =>
  state ? state.flagLoadingModuleContent : undefined
);

export const selectCardDetails = createSelector(selectFeature, (state: PaymentConclusionState) => (state ? state.cardDetails : undefined));

export const selectPaymentActionRequired = createSelector(selectFeature, (state: PaymentConclusionState) =>
  state ? state.actionRequired : undefined
);

export const selectTotalInstallments: MemoizedSelector<object, number> = createSelector(selectFeature, (state: PaymentConclusionState) =>
  state ? state.totalInstallments : undefined
);
